import { PiralPlugin } from 'piral-core';
import { SnowfallProps } from 'react-snowfall';

import * as actions from './actions';
import { isChristmasTime } from './components/SnowFallButton/SnowfallButton';
import { snowfallStorageKey, snowPileStorageKey } from './constants';
import { SnowfallApi } from './types';

export const defaultSettings: SnowfallProps = {
  snowflakeCount: 250,
  color: '#dee4fd',
  radius: [0.5, 3.0],
  speed: [1.0, 3.0],
  wind: [-0.5, 2.0],
  changeFrequency: 200,
};

/**
 * Creates new Pilet API extensions for enabling snowfall.
 */
export function createSnowfallApi(settings?: SnowfallProps): PiralPlugin<SnowfallApi> {
  const stored = localStorage.getItem(snowfallStorageKey);
  if (stored) {
    settings = JSON.parse(stored);
  } else {
    settings = settings || defaultSettings;
  }

  // Load snow pile setting from localStorage, default to false (opt-in)
  const storedSnowPile = localStorage.getItem(snowPileStorageKey);
  let snowPileEnabled = false;
  if (storedSnowPile !== null) {
    snowPileEnabled = JSON.parse(storedSnowPile);
  }

  if (!isChristmasTime()) {
    settings = null;
    localStorage.removeItem(snowfallStorageKey);
    localStorage.removeItem(snowPileStorageKey);
    snowPileEnabled = false;
  }

  return context => {
    context.defineActions(actions);

    context.dispatch(state => ({
      ...state,
      snowSettings: settings,
      snowPileEnabled,
    }));

    return {
      getSnowSettings() {
        return context.readState(state => state.snowSettings);
      },
    };
  };
}
